import VueCookies from "vue-cookies";
import { ACCESS_TOKEN, COOKIE_KEY } from "@/store/mutation-types";
const expire = 60 * 60 * 0.5; // 30m
const path = "/";
const domain = process.env.NODE_ENV === "development" ? null : ".jzyx.com";
export default {
  //设置
  setCookieToken: data => {
    // 前后端分离系统共享token
    VueCookies.set(ACCESS_TOKEN, data.token, expire, path, domain);
    // 老系统共享cookie
    VueCookies.set(COOKIE_KEY, data.cookie_value, expire, path, domain);
  },
  //移除
  removeCookieToken: () => {
    // 前后端分离系统共享token
    VueCookies.remove(ACCESS_TOKEN, path, domain);
    // 移除老系统共享的cookie
    VueCookies.set(COOKIE_KEY, "no", 0, path, ".jzyx.com");
  },
  //获取
  getCookieToken: () => {
    return VueCookies.get(ACCESS_TOKEN);
  }
};
